import React from "react";
import { RouteNames } from "../../router";
import style from "./NavList.module.css";
import { CustomLink } from "../../ui";

const NAV_ITEMS = [
  { path: RouteNames.HOME, text: "Home" },
  { path: RouteNames.ABOUT, text: "About" },
  { path: RouteNames.PORTFOLIO, text: "Gallery" },
  { path: RouteNames.REVIEWS, text: "Reviews" },
  { path: RouteNames.CONTACTS, text: "Contacts" },
];

export const NavList = ({ setNav, nav }) => {
  return (
    <ul
      id="primary-navigation"
      className={
        nav
          ? [style.menu, style.active, style.navList].join(" ")
          : [style.menu, style.navList].join(" ")
      }
    >
      {NAV_ITEMS.map((item) => (
        <li key={item.path}>
          <CustomLink
            {...item}
            color="black"
            onClick={() => setNav(false)}
          />
        </li>
      ))}
    </ul>
  );
};
